import React, {Component} from 'react';
import './App.css';
import {RedocStandalone} from 'redoc';
// import Spec from '../public/SubTruxAPI'

class App extends Component {
    render() {
        return (
            <div className="App">
                <RedocStandalone
                    specUrl="/SubTruxAPI.yaml"
                    // spec={Spec}
                    options={{
                        theme: {
                            colors: {
                                primary: {
                                    main: '#505050'
                                }
                            }
                        }
                    }}
                    onLoaded={() => {}}
                />
            </div>
        );
    }
}

export default App;
